import { useAuthStore } from "@/stores/auth.store";
import { matchPermission } from "@/lib/permissions";

/**
 * Check if the current user has ALL the required permissions.
 * Supports wildcard matching (students:*, *:*).
 */
export function usePermission(requiredPermissions: string[]): boolean {
  const permissions = useAuthStore((state) => state.permissions) ?? [];
  if (!requiredPermissions || requiredPermissions.length === 0) return true;
  return requiredPermissions.every((required) =>
    permissions.some((held) => matchPermission(held, required)),
  );
}

/**
 * Check if the current user has ANY of the required permissions.
 */
export function useAnyPermission(requiredPermissions: string[]): boolean {
  const permissions = useAuthStore((state) => state.permissions) ?? [];
  if (!requiredPermissions || requiredPermissions.length === 0) return true;
  return requiredPermissions.some((required) =>
    permissions.some((held) => matchPermission(held, required)),
  );
}
